<template>
	<div class="find_account_page">
		<div class="wrap">
			<div class="login_logo_pc">
				<img src="@/assets/images/v2/logo-white.svg" alt="janopay logo image" />
			</div>
			<div class="login_text">
				<div class="title">
					Empower Your Transactions with <br />
					Cryptographic Assets.
				</div>
				<div class="desc">
					With our platform, payments can be made instantly and seamlessly,
					without the need to exchange your <br />
					cryptographic assets-ensuring speed, security & convenience.
				</div>
			</div>
			<div class="card">
				<div class="find_account_card">
					<h1 class="logo">
						<img src="@/assets/images/logo.png" alt="janopay logo image" />
					</h1>
					<ul class="tab_area">
						<li :class="{ selected: selectedTab === 1 }">
							<a @click="selectedTab = 1" class="tab_item">{{
								$t('rtr_auth-find-account.text1')
							}}</a>
						</li>
						<li :class="{ selected: selectedTab === 2 }">
							<a @click="selectedTab = 2" class="tab_item">{{
								$t('rtr_auth-find-account.text2')
							}}</a>
						</li>
					</ul>
					<div v-if="selectedTab === 1">
						<p class="text_1">
							{{ $t('rtr_auth-find-account.text3') }}
						</p>
						<input
							type="text"
							v-model="emailAddress"
							:placeholder="$t('rtr_auth-find-account.placeholder1')"
						/>
						<div class="mt_20">
							<button type="button" class="w100 button_bg_blue" @click="findId">
								{{ $t('button.next') }}
							</button>
						</div>
					</div>
					<div v-if="selectedTab === 2">
						<div v-if="!token">
							<p class="text_1">
								{{ $t('rtr_auth-find-account.text4') }}
							</p>
							<input
								type="text"
								class="mb_10"
								v-model="userId"
								:placeholder="$t('rtr_auth-find-account.placeholder2')"
							/>
							<input
								type="text"
								v-model="emailAddress"
								:placeholder="$t('rtr_auth-find-account.placeholder1')"
							/>
							<div class="mt_20">
								<button
									type="button"
									class="button_bg_blue w100"
									@click="sendAuthCode"
								>
									{{ $t('button.next') }}
								</button>
							</div>
						</div>
						<div v-else>
							<p class="text_1">{{ $t('rtr_auth-find-account.text5') }}</p>
							<input
								type="text"
								class="mb_10"
								v-model="authCode"
								:placeholder="$t('rtr_auth-find-account.placeholder3')"
							/>
							<input
								type="password"
								class="mb_10"
								v-model="newPassword"
								:placeholder="$t('rtr_auth-find-account.placeholder4')"
							/>
							<input
								type="password"
								v-model="confirmPassword"
								:placeholder="$t('rtr_auth-find-account.placeholder5')"
							/>
							<div class="mt_20">
								<button
									type="button"
									class="button_bg_blue w100"
									@click="setNewPassword"
								>
									{{ $t('button.next') }}
								</button>
							</div>
						</div>
					</div>
					<router-link :to="{ name: 'auth-login' }" class="cancel">{{
						$t('rtr_auth-register.cancel')
					}}</router-link>
				</div>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon success"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button class="button_bg_blue" @click="onConfirm">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import ModalMessage from '@/components/Layout/ModalMessage';
import '@/assets/css/find_account.css';
import {
	findMemberId,
	findMemberPassword,
	findMemberPasswordToken,
} from '@/api/member';
import { commonError } from '@/common/dialog';

export default {
	name: 'FindAccount',
	components: { ModalMessage },
	data() {
		return {
			selectedTab: 1,
			emailAddress: '',
			userId: '',
			token: '',
			authCode: '',
			newPassword: '',
			confirmPassword: '',
			messageModal: false,
			modalStatusMessage: '',
		};
	},
	watch: {
		selectedTab() {
			this.emailAddress = '';
			this.userId = '';
			this.token = '';
			this.authCode = '';
		},
	},
	computed: {
		mode() {
			if (this.selectedTab === 1) {
				return 'findId';
			} else {
				if (!this.token) {
					return 'sendAuthCode';
				} else {
					return 'newPassword';
				}
			}
		},
	},
	methods: {
		async findId() {
			if (!this.validations()) return;
			const params = { email_address: this.emailAddress };
			await findMemberId(params)
				.then(() => {
					this.modalStatusMessage = this.$t('modal.message.sent_id');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		async sendAuthCode() {
			if (!this.validations()) return;
			const params = { user_id: this.userId, email_address: this.emailAddress };
			await findMemberPasswordToken(params)
				.then(({ token }) => {
					this.token = token;
					this.modalStatusMessage = this.$t('modal.message.sent_authCode');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		async setNewPassword() {
			if (!this.validations()) return;
			const params = {
				token: this.token,
				auth_code: this.authCode,
				new_password: this.newPassword,
				confirm_password: this.confirmPassword,
			};
			await findMemberPassword(params)
				.then(() => {
					this.modalStatusMessage = this.$t('modal.message.pw_changed');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		onConfirm() {
			if (this.mode === 'newPassword') {
				this.messageModal = false;
			} else {
				this.$router.push({ name: 'auth-login' });
			}
		},
		validations() {
			if (this.mode === 'findId') {
				if (!this.emailAddress) {
					alert(this.$t('alert.enter_email'));
					return false;
				}
			} else if (this.mode === 'sendAuthCode') {
				if (!this.userId) {
					alert(this.$t('alert.enter_email'));
					return false;
				}
				if (!this.emailAddress) {
					alert(this.$t('alert.enter_email'));
					return false;
				}
			} else if (this.mode === 'newPassword') {
				if (!this.authCode) {
					alert(this.$t('alert.enter_authCode'));
					return false;
				}
				if (!this.newPassword) {
					alert(this.$t('alert.enter_newPw'));
					return false;
				}
				if (!this.confirmPassword) {
					alert(this.$t('alert.enter_newPwConfirm'));
					return false;
				}
				if (this.newPassword !== this.confirmPassword) {
					alert(this.$t('alert.wrong_newInfo'));
					return false;
				}
			}
			return true;
		},
	},
};
</script>

<style>
.menu_sec,
.copyright {
	display: none;
}
</style>
